// Module
var code = "<div id=\"V-A6B2AD55-A38A-4305-988F-995FF5FF14E3\"> <div data-b-component=\"input\" class=\"input\" data-b-comp-text=\"{Binding value}\"></div> </div> ";
// Exports
export default code;